import { AppState } from '@app/store/app.state';
import { addDays, subDays } from 'date-fns';

export enum FilterControlEnum {
  Level = 'level_id',
  Grade = 'grade_id',
  Group = 'group_id',
  Subject = 'subject_ids',
  UserGroup = 'user_group_ids',
  Author = 'author_id',
  Generic = 'generic_status',
}

export enum FilterTypeEnum {
  Shortcut,
  Calendar,
  Extra,
}

export enum StatusFilterTypeEnum {
  IsConcluded = 'is_concluded',
  HasAnswers = 'has_answers',
  HasAttachments = 'has_attachments',
  isPinned = 'is_pinned',
}

export interface StatusFilter {
  key: string;
  type: StatusFilterTypeEnum;
  value: any;
  description: string;
}
export interface FilterForm {
  fixed: FilterControlEnum[];
  filters: FilterControlEnum[];
}

export type Filter = (state: AppState) => {
  status: StatusFilter[];
  filters: FilterForm;
};

export const INTERVAL = 6;

export const FILTERS = [
  { icon: 'icon-filter-question', value: FilterTypeEnum.Shortcut },
  { icon: 'icon-calendar-2', value: FilterTypeEnum.Calendar },
  { icon: 'icon-config', value: FilterTypeEnum.Extra },
];

export const statusFilter = [];

export const SHORTCUTS = [
  {
    label: 'eclass.agenda.filtros.recentes',
    value: { date_min: subDays(new Date(), 15), date_max: new Date() },
  },
  {
    label: 'eclass.agenda.filtros.15-dias',
    value: { date_min: new Date(), date_max: addDays(new Date(), 15) },
  },
  {
    label: 'eclass.agenda.filtros.30-dias',
    value: { date_min: new Date(), date_max: addDays(new Date(), 30) },
  },
];
